module.exports = __webpack_public_path__ + "img/belgium-stomach-cancer-female.9924d06f.png";